import React from "react";

const icon = () => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 255 255">
      <g fill="currentColor">
        <polygon fill="currentColor" points="0,63.75 127.5,191.25 255,63.75" />
      </g>
    </svg>
  );
};
export default icon;
